import { api } from '@/api/factory';

class Files {
    constructor() {}

    /**
     * Список файлов хранилища.
     *
     * @param path   подкаталог (null — корень)
     * @param search подстрока пути; отбор идёт на сервере ДО лимита, поэтому
     *               находит файлы за пределами первых 1000 записей
     */
    get(path = null, search: string | null = null) {
        return api({
            url: '/v1/content-manager/files/search?mask=*',
            method: 'GET',
            params: {
                path: path,
                search: search
            }
        })
    }

    getAudioTracks(path: string) {
        return api({
            url: '/v1/content-manager/files/audio-tracks',
            method: 'GET',
            params: {
                path: path
            }
        })
    }
}

export default Files